import { FC } from 'react';
import dayjs from 'dayjs';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import QuizTypes from 'types/QuizTypes';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';

type Props = {
  isLargeScreen: boolean;
}

const AppBar:FC<Props> = ({ isLargeScreen }) => {
  const { t } = useTranslation('common');

  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;


  const quizName = result.quizGroup ? result.quizGroup.name : quiz?.quizName;
  const title = quiz
    ? quiz.publicLeaderboard.headerText || `${quizName} ${t('common.leaderboard')}`
    : t('common.leagueLeaderboard');

  const quizEnded = dayjs().isAfter(Number(quiz?.endsDate));

  if (!result) return null;
  return (
    <div
      className="
        relative z-40 overflow-hidden
        shrink-0 flex items-center justify-between
        py-2
      "
      style={{ fontFamily: 'Montserrat' }}
    >
      <div className="grow">
        <h2 className="text-inherit font-bold uppercase" style={{ fontFamily: 'Gotham', fontSize: isLargeScreen ? '55px' : '20px', lineHeight: '120%' }}>{title}</h2>
        {quiz && quiz.type === QuizTypes.Prediction && quizEnded && (
          <p className="text-white ml-1 sm:text-md">
            {quiz.numberOfQuestions === quiz.numberOfAnsweredQuestions
              ? t('quiz.leaderboardPage.finalResults')
              : t('quiz.leaderboardPage.answeredQuestions', { questions: quiz.numberOfQuestions, answeredQuestions: quiz.numberOfAnsweredQuestions })
            }
          </p>
        )}
      </div>
    </div>
  )
}

export default AppBar;
